import React from "react";
import Marquee from "react-fast-marquee";
import { useSite } from "@/context/SiteContext";
import { resolveAssetUrl } from "@/lib/api";

export default function Partners() {
  const { partners, content } = useSite();
  if ((content?.partners_visible ?? "true") !== "true") return null;
  if (!partners?.length) return null;

  return (
    <section data-testid="partners-section" className="py-14 bg-white border-y border-slate-100">
      <div className="dc-container">
        <div className="text-center mb-8">
          <span className="text-xs font-semibold uppercase tracking-[0.25em] text-dc-muted">Tecnologias e parceiros</span>
        </div>
        <div className="marquee-mask">
          <Marquee gradient={false} speed={40} pauseOnHover>
            {partners.concat(partners).map((p, i) => (
              <div key={`${p.id}-${i}`} className="mx-12 flex items-center justify-center h-12">
                <img
                  src={resolveAssetUrl(p.logo_url, p.logo_url)}
                  alt={p.name}
                  className="h-8 md:h-10 max-w-[160px] object-contain grayscale opacity-60 hover:opacity-100 hover:grayscale-0 transition duration-300"
                />
              </div>
            ))}
          </Marquee>
        </div>
      </div>
    </section>
  );
}
